import { API } from "../../backend";
import axios from "axios";


export const signin = (mobile) => {
    return fetch(`${API}api/v1/user/login/`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ mobile })
    })
    .then((response) => {
        return response.json();
    })
    .catch((err) => console.log(err));
};

export const verify = (mobile, otp) => {
    return fetch(`${API}api/v1/user/verify/`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ mobile , otp})
    })
    .then((response) => {
        return response.json();
    })
    .catch((err) => console.log(err));
};


export const getUserInfo = async (token) => {
    try {
      const response = await axios.get(`${API}api/v1/user/`, {
        headers: {
          "Authorization": `Token ${token}`,
          "Content-Type": "application/json",
        },
      });
  
      if (Array.isArray(response.data) && response.data.length > 0) {
        return response.data[0]; // Return the first user object
      } else {
        console.error("Invalid user data format:", response.data);
        return null;
      }
    } catch (error) {
      console.error("Error fetching user info:", error.response ? error.response.data : error.message);
      return null; // Return null if an error occurs
    }
  };
